module.exports = __webpack_public_path__ + "img/lacrosse-stick.732883e7.svg";